import React from "react";
import "./LoadingComponent.css";

export const LoadingComponent = () => {
  return <div className="loading-component" />;
};
